import { connect } from 'react-redux';

import * as WebViewActions from '@medscape-promo/medscapetv/web-view/web-view.actions';
import { EMBD_LNK } from '@medscape-promo/medscapetv/omniture-tracking';
import BreadcrumbComponent from './breadcrumb.component';

const mapStateToProps = (state, ownProps) => {
    const props = Object.assign({},ownProps,{
    	"routing": state.WebView.isIframe === false
    })
    return props;
};
const mapDispatchToProps = dispatch => {
    return {
    	onLinkClick: (el) => {
    		dispatch(WebViewActions.omnitureTracking(EMBD_LNK));
    	}
    }
};

const Breadcrumb = connect(mapStateToProps, mapDispatchToProps)(BreadcrumbComponent);
export default Breadcrumb;